import changeCompany from './change-company';
import sendAfToken from './send-af-token';
import primitiveHelpers from './primitive-helpers';
import attachments from './attachments';
import notifications from './notifications';
import kendoWindows from './kendoWindows';
import events from './events';
import ObjectExtensions from './object-extensions';
import setupSessionTimeout from './session-timeout';

export {sendAfToken};
export {primitiveHelpers};

export default function () {
    // Add changeCompany event items
    const companySelectElements = $('#changeCompany--js').find('a');
    if (companySelectElements.length) {
        companySelectElements.on('click', changeCompany);
    }
    setupTextAreas();

    attachments();

    notifications();
    kendoWindows();
    ObjectExtensions();
    events();

    if (window.sessionTimeoutMinutes && window.user) {
        setupSessionTimeout();
    }
}

export const setupTextAreas = function () {
    const $textAreas = $('textArea:enabled');
    if ($textAreas.length) {
        $.each($textAreas, function (k, v) {
            let infoDiv = document.createElement('div'), $ele = $(v), charLimit = Number($ele.attr('data-limit') || 500), val = $ele.val(), len = val.length;

            infoDiv.classList.add('t-right');
            infoDiv.classList.add('form-item__description');
            infoDiv.setAttribute('data-info-for', v.name);
            if(charLimit > 0) infoDiv.innerHTML = (charLimit - len) + ' characters remaining';
            v.after(infoDiv);

            if(charLimit > 0) {
                $ele.on('keyup change', function () {
                    let val = $ele.val();
                    let len = val.length;
                    if (len >= charLimit) {
                        $ele.val(val.substring(0, charLimit));
                        len = charLimit;
                    }
                    $(infoDiv).text((charLimit - len) + ' characters remaining');
                });
            }
        });
    }
};
